export const INSIGHTS_PLATFORM_URL = 'https://insights.planet.com';

export const AM_APP_URL = import.meta.env.VITE_AM_APP_URL;
